var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_682_10262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_682_10262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0749 2C6.5196 2 2 6.38619 2 11.7775C2 17.1689 6.5196 21.5551 12.0749 21.5551L18.185 24L28 21.5551V2H12.0749Z",
    fill: "#E0D14A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 6.10404C54.9571 6.10404 52.4816 8.6721 52.4816 11.8285C52.4816 14.9848 54.9572 17.5529 58 17.5529V20H24.2845L20 14.4576V7.81708L24.7885 4H58V6.10404Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7.70783V10H52.7341C53.4376 7.68448 55.5321 6 58 6H22.1489L20 7.70783Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7794 17.9115H27.8338C24.8602 17.9115 22.4411 15.3835 22.4411 12.2762C22.4411 9.169 24.8603 6.64093 27.8338 6.64093H57.7794C59.0058 6.64093 60 5.60204 60 4.32046C60 3.03889 59.0058 2 57.7794 2H27.8338C22.4113 2 18 6.6099 18 12.2762C18 17.9426 22.4114 22.5525 27.8338 22.5525L42.9335 26L52.704 22.5525H57.7794C59.0058 22.5525 60 21.5136 60 20.232C60 18.9502 59.0058 17.9115 57.7794 17.9115Z",
    fill: "#FADA6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9251 22H36V42.6475L46.8117 46L51.925 42.6475C57.4805 42.6475 62 38.0163 62 32.3238C62 26.6313 57.4805 22 51.9251 22Z",
    fill: "#D75758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 26.1043C9.04287 26.1043 11.5184 28.6723 11.5184 31.8286C11.5184 34.9849 9.04275 37.5529 6 37.5529V40H39.7155L44 34.4575V27.817L39.2115 24H6V26.1043Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2285 30H44V27.7067L41.85 26H6C8.45202 26.02 10.5287 27.6976 11.2285 30Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1662 22H6.22056C4.99416 22 4 23.0437 4 24.3312C4 25.6187 4.99416 26.6624 6.22056 26.6624H36.1662C39.1398 26.6624 41.5589 29.2022 41.5589 32.3238C41.5589 35.4454 39.1397 37.9851 36.1662 37.9851H6.22056C4.99416 37.9851 4 39.0288 4 40.3163C4 41.6038 4.99416 42.6475 6.22056 42.6475H11.296L16.5196 46L36.1662 42.6475C41.5887 42.6475 46 38.0163 46 32.3238C46 26.6312 41.5887 22 36.1662 22Z",
    fill: "#EA5F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0749 61.9999C6.5196 61.9999 2 57.5139 2 51.9999C2 46.486 6.5196 42 12.0749 42H28V62H12.0749V61.9999Z",
    fill: "#346CC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 46.1042C54.9571 46.1042 52.4816 48.6722 52.4816 51.8285C52.4816 54.985 54.9572 57.5529 58 57.5529V60H24.2845L20 54.4576V47.817L24.7885 44H58V46.1042Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 46H22.1548L20 47.7014V50H52.9494C53.6315 47.76 55.6239 46.1098 58 46Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7794 62H27.8338C22.4113 62 18 57.514 18 52C18 46.486 22.4114 42 27.8338 42H57.7794C59.0058 42 60 43.011 60 44.2581C60 45.5052 59.0058 46.5162 57.7794 46.5162H27.8338C24.8602 46.5162 22.4411 48.9763 22.4411 52C22.4411 55.0238 24.8603 57.4838 27.8338 57.4838H57.7794C59.0058 57.4838 60 58.4948 60 59.7419C60 60.9893 59.0058 62 57.7794 62Z",
    fill: "#4582DE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.0cb5c28ddab3962ca2661b8c7e36c7b5.svg";
export { ForwardRef as ReactComponent };